import { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTimeSheet,
  getTimesheetCSV,
  getTimeSheetMember,
  getTimesheetXLSX,
} from '../../../redux/MainAction';
import moment from 'moment';
import AddTimeSheetModal from './AddTimeSheetModal';
import { FaFileCsv, FaFileExcel } from 'react-icons/fa';
import { downloadXLS, downloadCSV } from '../../../helpers/helpers';
import { toast } from 'react-toastify';
import { FaClock } from 'react-icons/fa';

const TimeSheet = () => {
  const dispatch = useDispatch();
  const member = useSelector((state) => state?.Webtracker?.timesheetMember);
  const sheet = useSelector((state) => state?.Webtracker?.timesheet);

  const date = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(date.getDate() - 1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showReset, setShowReset] = useState(false);

  const [filters, setFilters] = useState({
    employeeId: '',
    startDate: moment(tomorrow).format('YYYY-MM-DD'),
    endDate: moment(date).format('YYYY-MM-DD'),
  });

  const dispatchCalls = (data) => {
    dispatch(getTimeSheet(data));
  };

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    const data = {
      offset: 0,
      limit: 100,
    };
    dispatch(getTimeSheetMember(data));
  };

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const convertSeconds = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h : ${minutes}m`;
  };

  const handleApply = (e) => {
    e.preventDefault();
    if (filters?.startDate && filters?.endDate) {
      const startDate = moment(filters.startDate);
      const endDate = moment(filters.endDate);

      if (startDate.isAfter(endDate)) {
        toast.error('Start date cannot be greater than End date', {
          position: 'top-right',
        });
        return;
      }
    }

    const payload = {};

    if (filters?.employeeId !== '') {
      payload.employeeId = filters.employeeId;
    }

    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }

    if (filters?.endDate) {
      payload.endDate = filters.endDate;
    }
    dispatchCalls(payload);
    setShowReset(true);
  };

  const handleReset = (e) => {
    e.preventDefault();

    setShowReset(false);
    setFilters({
      employeeId: '',
      startDate: moment(tomorrow).format('YYYY-MM-DD'),
      endDate: moment(date).format('YYYY-MM-DD'),
    });
  };

  async function downloadCSVHandler(isCSV) {
    const payload = {};

    if (filters?.employeeId !== '') {
      payload.employeeId = filters.employeeId;
    }

    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }

    if (filters?.endDate) {
      payload.endDate = filters.endDate;
    }

    if (isCSV) {
      const csv = await dispatch(getTimesheetCSV(payload));
      downloadCSV(csv, 'Timesheet');
    } else {
      const xlsx = await dispatch(getTimesheetXLSX(payload));
      downloadXLS(xlsx, 'Timesheet');
    }
  }

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2">
          <h5 className="text-muted col-4"></h5>
          <div className="col-8 d-flex justify-content-end align-items-center">
            <Button
              className="d-flex align-items-center"
              size="sm"
              color="dark"
              onClick={toggleModal}
            >
              <FaClock className="mr-1" /> Add Time
            </Button>
          </div>
        </div>
        <AddTimeSheetModal open={isModalOpen} onClose={toggleModal} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card m-b-20">
                <div className="d-flex justify-content-between align-items-center m-2">
                  <div className="d-flex justify-content-start align-items-center">
                    <select
                      className="form-control font-14"
                      name="employeeId"
                      value={filters?.employeeId}
                      onChange={onChangeFilter}
                    >
                      <option value="">Select Member</option>
                      {member?.rows?.map((mems, idx) => (
                        <option key={idx} value={mems?.employeeId}>
                          {mems?.user?.firstName} {mems?.user?.lastName}
                        </option>
                      ))}
                    </select>
                    <div
                      className="d-flex align-items-center font-14 ml-2"
                      style={{ gap: '5px' }}
                    >
                      <input
                        type="date"
                        className="form-control font-14"
                        name="startDate"
                        value={filters?.startDate}
                        onChange={onChangeFilter}
                        max={moment().format('YYYY-MM-DD')}
                      />
                      To
                      <input
                        type="date"
                        className="form-control font-14"
                        name="endDate"
                        value={filters?.endDate}
                        onChange={onChangeFilter}
                        max={moment().format('YYYY-MM-DD')}
                      />
                    </div>
                    <Button
                      className="d-flex align-items-center justify-content-center ml-2"
                      style={{ padding: '6px 14px' }}
                      size="sm"
                      color="primary"
                      onClick={handleApply}
                    >
                      <i className="ion-ios7-search font-20"></i>
                    </Button>

                    {showReset ? (
                      <Button
                        className="d-flex align-items-center justify-content-center ml-2"
                        style={{ padding: '6px 13px' }}
                        size="sm"
                        color="danger"
                        onClick={handleReset}
                      >
                        <i className="mdi mdi-close font-20"></i>
                      </Button>
                    ) : (
                      ''
                    )}
                  </div>

                  <div>
                    <Button
                      color="success"
                      size="sm"
                      className="mx-2 d-flex align-items-center"
                      onClick={() => downloadCSVHandler(true)}
                    >
                      <FaFileCsv className="mr-1" /> CSV
                    </Button>

                    {/* <Button
                      color="primary"
                      size="sm"
                      className="mr-2 d-flex align-items-center"
                      onClick={() => downloadCSVHandler()}
                    >
                      <FaFileExcel className="mr-1" /> XLSX
                    </Button> */}
                  </div>
                </div>
                <div className="card-body">
                  <table
                    id="datatable"
                    className="table dt-responsive nowrap table-vertical"
                    width="100%"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>Employee's Timezone</th>
                        <th>Manually Added</th>
                        <th>Project</th>
                        <th>Task</th>
                        <th>Description</th>
                        <th>Amount</th>
                        <th>Total Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filters?.employeeId && sheet?.activities?.length > 0 ? (
                        sheet?.activities?.map((day, dateIndex) => (
                          <>
                            <tr key={dateIndex} className="table-date-row">
                              <td colSpan="7">
                                <strong>Date:</strong> {day?.date}
                              </td>
                            </tr>
                            {day?.activities?.length > 0 ? (
                              day?.activities?.map(
                                (activity, activityIndex) => (
                                  <tr key={`${dateIndex}-${activityIndex}`}>
                                    <td>
                                      {convertSeconds(activity?.totalTime)}
                                    </td>
                                    <td>{activity?.timezone}</td>
                                    <td>{`${activity?.manuallyAddedPercent}%`}</td>
                                    <td>{activity?.projectName}</td>
                                    <td>{activity?.taskName}</td>
                                    <td>{activity?.description}</td>
                                    <td>{activity?.totalAmount}</td>
                                    <td>
                                      {convertSeconds(activity?.totalTime)}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr key={`${dateIndex}-no-activities`}>
                                <td colSpan="7" className="text-center">
                                  No activities available for this date.
                                </td>
                              </tr>
                            )}
                          </>
                        ))
                      ) : (
                        <tr key={`no-member-selectin`}>
                          <td colSpan="8" className="text-center">
                            Please select the member to view the time sheet.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default TimeSheet;
